import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ThemedApp from './ThemedApp';
import { LocalizationProvider } from '@mui/x-date-pickers-pro/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFns';
import { LicenseInfo } from '@mui/x-license';
import { SnackbarProvider as SnackbarProviderBase } from 'notistack';
import type { ComponentType } from 'react';

// Workaround for notistack class component type incompatibility with @types/react 18.3+
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const SnackbarProvider = SnackbarProviderBase as unknown as ComponentType<any>;
import App from './App';

// Set MUI X Premium license key (get from MUI)
LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_LICENSE_KEY || '');

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

// Register service worker for PWA install support
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js');
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemedApp>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <SnackbarProvider
            maxSnack={3}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            autoHideDuration={5000}
          >
            <App />
          </SnackbarProvider>
        </LocalizationProvider>
      </ThemedApp>
    </QueryClientProvider>
  </React.StrictMode>
);
